import { useTranslation } from "react-i18next";
import SectionHeader from "../common/SectionHeader";
import { getLandingProjects } from "../../utils/landingAcf";
import { SECTION_CONTAINER } from "../../utils/layout";
import LandingSection from "./LandingSection";
import ScrollReveal, { revealItemProps } from "./ScrollReveal";
import SectionLoader from "../common/SectionLoader";
import "./LandingSections.css";

function LandingProjects({ acf, resolveImage, loading = false }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <LandingSection className="landing-projects">
        <SectionLoader size="lg" label={t("Loading section")} />
      </LandingSection>
    );
  }

  const { title, description, images } = getLandingProjects(acf);

  if (!title && !description && images.length === 0) return null;

  return (
    <LandingSection className="landing-projects">
      {title || description ? (
        <ScrollReveal className="landing-section__intro">
          <SectionHeader
            title={title || undefined}
            subtitle={description || undefined}
            showAccent
            centered
            titleId="landing-projects-title"
            containerClass=""
          />
        </ScrollReveal>
      ) : null}
      {images.length > 0 ? (
        <div className={SECTION_CONTAINER}>
          <ScrollReveal
            className="landing-projects__grid landing-section__body"
            stagger
            aria-labelledby={title ? "landing-projects-title" : undefined}
          >
            {images.map(({ id, imageId }, index) => {
              const src = resolveImage(imageId);
              if (!src) return null;
              return (
                <figure
                  key={id}
                  {...revealItemProps(
                    index,
                    "caf-media-frame aspect-square overflow-hidden",
                  )}
                >
                  <img src={src} alt="" loading="lazy" className="h-full w-full object-cover" />
                </figure>
              );
            })}
          </ScrollReveal>
        </div>
      ) : null}
    </LandingSection>
  );
}

export default LandingProjects;
